import {FileUploadItem} from './FileUploadItem';

import type {PendingFile} from './file-upload.types';

export interface PendingFileListProps {
  pendingFiles: PendingFile[];
  progress?: number;
  uploadingLabel?: string;
  isUploading: boolean;
  onRemove: (id: string) => void;
}

export function PendingFileList({
  pendingFiles,
  progress,
  uploadingLabel,
  isUploading,
  onRemove
}: PendingFileListProps) {
  if (pendingFiles.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      {pendingFiles.map(item => (
        <FileUploadItem
          key={item.id}
          fileName={item.file.name}
          fileSize={item.file.size}
          progress={progress ?? 0}
          uploadingLabel={uploadingLabel}
          onRemove={async () => onRemove(item.id)}
          isLoading={isUploading}
        />
      ))}
    </div>
  );
}
